module.exports = __webpack_public_path__ + "static/media/104.1518ebbc.gif";